module.exports = __webpack_public_path__ + "img/header-img.aa14810b.png";